import { useMediaQuery } from "./useMediaQuery";

export function useIsMobile(maxWidth: number = 640) {
  return useMediaQuery(`(max-width: ${maxWidth}px)`);
}
